import './validation-package/_jquery.js'
import './validation-package/_jquery.validationEngine-ja.js'
import './validation-package/_jquery.validationEngine.js'
/*
jQuery-Validation-Engineによるバリデーション
https://github.com/posabsolute/jQuery-Validation-Engine

※preset/_js.scssのCSSを有効化する必要がある
※エラーのツールチップを配置するため、各入力欄の親はposition:relativeである必要がある

「.js-validation」の配下のformに反応する

<div class="js-validation">
    <form action="./" method="get">
    </form>
</div>
*/

//   ####  ##        ###     ####   ####
//  ##     ##       ## ##   ##     ##
//  ##     ##      ##   ##   ###    ###
//  ##     ##      #######     ##     ##
//   ####  ######  ##   ##  ####   ####
/*
input属性とバリデーションクラスの対応表を作る
WPプラグインではクラス名に[]が使えないためこちらの処理でクラス当てる

const inputList = {
  '/contact/': { //  ← URLパターン（フォームの識別用）
  user: 'validate[required]', // ← name属性 : 当てるクラス
  mail: 'validate[required,custom[email]]',
  },
}

※データ構造の都合でname属性に「-」は使用不可　「_」推奨

*/
// ドメインと適用バリデーションの組み合わせ
const inputList = {
  '/entry/': {
    type: 'validate[required]',
    text: 'validate[required]',
    user: 'validate[required]',
    ruby: 'validate[required]',

    email: 'validate[required,custom[email]]',
    // tel: 'validate[required,custom[phone]]',
    tel: 'validate[required,custom[phone],minSize[10]]',
    ok: 'validate[required]',
  },
  '/contact/': {
    company: 'validate[required]',
    pos: 'validate[required]',

    user: 'validate[required]',
    ruby: 'validate[required]',
    email: 'validate[required,custom[email]]',
    // tel: 'validate[required,custom[phone]]',
    tel: 'validate[required,custom[phone],minSize[10]]',
    text: 'validate[required]',
    ok: 'validate[required]',
  },
}
/*
■必須入力
validate[required]
■指定の書式
validate[custom[email]]
validate[custom[phone]]
validate[custom[url]]
custom[date]
■複合
validate[required,custom[email]]
validate[required,custom[phone]]
■指定IDと入力内容が一致
validate[equals[id]]
■指定IDがチェック済みなら必須入力に変更
validate[condRequired[id]]
■指定範囲の文字数
validate[maxSize[10]]
validate[minSize[10]]
■整数のみ
validate[custom[integer]]
■数字のみ
validate[custom[number]]
■英数字のみ
validate[custom[onlyLetterNumber]]
■英字と空白のみ
validate[custom[onlyLetterSp]]
■数字と空白のみ
validate[custom[onlyNumberSp]]
■指定範囲の数値
validate[min[-5]]
validate[max[30]]
■指定範囲の日付
validate[custom[date],past[2010/01/01]]
validate[custom[date],future[NOW]]
■チェックボックスのチェック数
validate[minCheckbox[2]]
validate[maxCheckbox[2]】
*/

// inputListの記載内容を反映
validationClassSet()
function validationClassSet() {
  for (const url in inputList) {
    if (!inputList.hasOwnProperty(url)) {
      continue
    }
    // console.log(url)
    if (!~location.href.indexOf(url)) {
      continue
    }

    for (const name in inputList[url]) {
      const validationClass = inputList[url][name]
      // console.log(name)
      // console.log(validationClass)

      if (!validationClass) {
        // 当てるクラスがない
        continue
      }

      // 対象のname属性を探す　配列版[]も考慮して探す
      const targetList = document.querySelectorAll('[name="' + name + '"],[name="' + name + '[]"]')

      for (const target of targetList) {
        // console.log(target)
        target.classList.add(validationClass)
      }
    }
    return
  }
}

//   ####  #####  ######  ##   ##  #####
//  ##     ##       ##    ##   ##  ##  ##
//   ###   #####    ##    ##   ##  #####
//     ##  ##       ##    ##   ##  ##
//  ####   #####    ##     #####   ##
// 初期化
if (document.querySelector('.js-validation form')) {
  if (document.querySelector('[name^="ok"]')) {
    // 規約同意のエラー文を変更する
    document.querySelector('[name^="ok"]').setAttribute('data-errormessage', '同意の上チェックしてください')
  }

  $('.js-validation form').validationEngine({
    scrollOffset: 200,
  })
}
